export const getAppTourProgress = state => state.appTour.appTourProgress;
export const getAppTourlastStep = state => state.appTour.lastStep;
export const getTourCreatedPage = state => state.appTour.page;
export const getPublishStatus = state => state.appTour.status;
export const getWizardEnabled = state => state.appTour.wizardEnabled;
export const getExistingPages = state => state.appTour.existingPages;
export const getWizardCanBeShown = state => state.appTour.wizardCanBeShown;
